import type { Module } from "vuex";
import type { State } from "@/store/state";
import type { AssetState } from "./state";
import { mutations } from "./mutations";
import { getters } from "./getters";
import { actions } from "./actions";

const defaultState: AssetState = {
  assets: [],
};

export const assetsModule: Module<AssetState, State> = {
  namespaced: true,
  state: defaultState,
  mutations,
  actions,
  getters,
};
